var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#7CCCF5",
    mask: "url(#mask-2)",
    x: 0,
    y: 9.33333333,
    width: 28,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,9.33333333 C11.3333333,10.3191151 11.8682284,11.1799654 12.663612,11.6414778 M15.4348494,11.5814633 C16.175601,11.107701 16.6666667,10.2778644 16.6666667,9.33333333",
    id: "Oval-5",
    stroke: "#445F42",
    strokeWidth: 1.33333333,
    strokeLinecap: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#D89F3D",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 8.66666667,
    rx: 1.33333333,
    ry: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/SM.9404ca4d622d948c760839dcdccb8ca6.svg";
export { ForwardRef as ReactComponent };